// extracted by mini-css-extract-plugin
export default {"productDescription":"dea-z","featuredDescription":"eea-z","description":"fea-z","more":"gea-z","descriptionSku":"hea-z"};